module.exports = __webpack_public_path__ + "img/thsq.c4b18d2e.png";